<div>
  <mat-tab-group *transloco="let t; read: 'building'">
    @if (canHaveDocuments$ | async) {
    <mat-tab class="mat-tab" label="{{ t('title') }}">
      <sibat-building-documents-detail [building]="building$ | async"></sibat-building-documents-detail>
    </mat-tab>
    } @for (casePreview of (casesPreview$ | async); track casePreview) {
    <!-- TO DO : possibilité d'enlever hasPolicyCaseAccess car l'onglet Document situé un cran plus haut fait deja cette restriction (les CECB n'ont pas accès aux documents) -->
    @if (hasPolicyCaseAccess$ | async) {
    <mat-tab class="mat-tab" [label]="getCaseTabLabel(casePreview)" data-test="case-tabs">
      <sibat-file-browser [root]="casePreview.caseId" [sharePointUrl]="casePreview.url" [caseType]="casePreview.type"> </sibat-file-browser>
    </mat-tab>
    } }
  </mat-tab-group>
</div>
